export default __webpack_public_path__ + "static/media/image.6300eaf0.svg";